import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('UserCollectionAlbum')
export class UserCollectionAlbum {

  @JsonProperty('album_id', Number)
  albumId: number = 0;

  @JsonProperty('name', String)
  name: string = '';

  @JsonProperty('is_reward_granted', Boolean)
  isRewardGranted: boolean = false;

  @JsonProperty('cards_count', Number)
  cardsCount: number = 0;

  @JsonProperty('cards_unique_count', Number)
  cardsUniqueCount: number = 0;
}
